import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fbadfc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-container" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_carousel = _resolveComponent("a-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_carousel, {
      "dots-class": "dot",
      autoplay: true,
      autoplaySpeed: 5000
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.homeService.banner, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.type,
            class: "img-container"
          }, [
            _createElementVNode("div", {
              class: "img-box",
              style: _normalizeStyle(`background-image: url(${item.banner})`),
              onClick: ($event: any) => (_ctx.onBannerClick(item))
            }, null, 12, _hoisted_2)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}